<div class="container-fluid">
  <app-header titleText="{{pageTitle}}" isAdmin="true">
    <div account>
      <img src="assets/img/circle_images/admin_circle.png" class="account-image" width="60" alt="My Account Icon" />
      <label class="text-bidit-account-header" i18n>My Account</label>
    </div>
    <div button>
      <a routerLink="/admin/account" class="btn btn-bidit-navigate btn-sm account-button">Edit Account</a>
      <select *ngIf="idiAdmin" class="form-control select-bidit"
              (change)="selectDealer()" [(ngModel)]="selectedDealer">
        <option [ngValue]="null">IDI</option>
        <option *ngFor="let dealer of dealers" [(ngValue)]="dealer.dealer_ID">{{dealer.dealer_BusinessName}}</option>
      </select>
    </div>
  </app-header>
  <div class="card bg-light">
    <div class="card-body">
      <img src="assets/img/circle_images/business_management_circle.png" alt="Lead Icon" class="card-icon" />
      <div class="bidit-card-title">
        <h4 class="text-bidit-account-header" i18n>Business Management</h4>
        <div i18n>Customize all aspects of BIDIT to your business needs. Simply click on the tab to edit the appropriate area.</div>
      </div>
      <div>
        <mat-tab-group class="bg-light">
          <mat-tab class="ml-3" label="Users" i18n-label>
            <ng-template matTabContent>
              <div class="row bg-white">
                <div class="col-md-12 col-lg-6 ">
                  <app-admin-list listType="user"></app-admin-list>
                </div>
                <div class="col-md-12 col-lg-6 ">
                  <app-admin-list listType="role"></app-admin-list>
                </div>
              </div>
            </ng-template>
          </mat-tab>
          <mat-tab label="Offices" i18n-label>
            <ng-template matTabContent>
              <div class="content">
                <app-admin-list listType="office"></app-admin-list>
              </div>
            </ng-template>
          </mat-tab>
          <mat-tab label="Vendors" i18n-label>
            <ng-template matTabContent>
              <div class="bg-white ">
                <div class="col-md-12">
                  <app-admin-list listType="vendor"></app-admin-list>
                </div>
                <div class="col-md-12 col-lg-6 ">
                  <app-admin-list listType="vendortype"></app-admin-list>
                </div>
              </div>
            </ng-template>
          </mat-tab>
          <mat-tab *ngIf="selectedDealer" label="Warehouses" i18n-label>
            <ng-template matTabContent>
              <app-admin-list listType="warehouse"></app-admin-list>
            </ng-template>
          </mat-tab>
          <mat-tab *ngIf="!quoteOnly" label="Resources" i18n-label>
            <ng-template matTabContent>
              <div class="row bg-white ">
                <div class="col-md-12 col-lg-6 ">
                  <app-admin-list listType="ResourceType"></app-admin-list>
                </div>
                <div class="col-md-12 col-lg-6 ">
                  <app-admin-list *ngIf="selectedDealer" listType="Resource"></app-admin-list>
                </div>
              </div>
              <div class="row bg-white">
                <div class="col-md-12 col-lg-6 ">
                  <app-admin-list *ngIf="selectedDealer" listType="Crew"></app-admin-list>
                </div>
                <div class="col-md-12 col-lg-6 ">
                  <app-admin-list *ngIf="selectedDealer" listType="FieldTechnician"></app-admin-list>
                </div>
              </div>
            </ng-template>
          </mat-tab>
          <mat-tab label="Competitors" i18n-label>
            <ng-template matTabContent>
              <div class="row bg-white">
                <div *ngIf="selectedDealer" class="col-md-12 col-lg-6">
                  <app-admin-list listType="Competitor"></app-admin-list>
                </div>
                <div class="col-md-12 col-lg-6 ">
                  <app-admin-list class="mt-5" listType="LostReason"></app-admin-list>
                </div>
              </div>
            </ng-template>
          </mat-tab>
          <mat-tab label="Documents" i18n-label>
            <ng-template matTabContent>
              <div class="row bg-white">
                <div *ngIf="selectedDealer" class="col-md-12">
                  <app-admin-list class="col-md-12" listType="Document"></app-admin-list>
                </div>                
              </div>
            </ng-template>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
